/**
 * Main Application Database Configuration
 * This configuration is specifically for the main application
 */

export const DB_CONFIG = {
  NAME: 'offlineDB',
  VERSION: 2,
  STORE_CONFIGS: {
    apiCache: { keyPath: 'id', autoIncrement: true },
    syncQueue: { keyPath: 'id', autoIncrement: true },
    ticketAccess: { keyPath: 'id', autoIncrement: true },
    ticketGroups: { keyPath: 'id', autoIncrement: true },
    userAccess: { keyPath: 'id', autoIncrement: true },
    tickets: { keyPath: 'id', autoIncrement: true },
    ticket_images: { keyPath: 'id', autoIncrement: true },
    ticket_logs: { keyPath: 'id', autoIncrement: true },
    ticket_messages: { keyPath: 'id', autoIncrement: true },
    ticket_users: { keyPath: 'id', autoIncrement: true },
    customers: { keyPath: 'id', autoIncrement: true },
    contracts: { keyPath: 'id', autoIncrement: true },
    contract_items: { keyPath: 'id', autoIncrement: true },
    customer_contacts: { keyPath: 'id', autoIncrement: true },
    customer_contact_links: { keyPath: 'id', autoIncrement: true },
    customer_credit_score: { keyPath: 'id', autoIncrement: true }
  },
  INDEXES: {
    tickets: [
      { name: 'ticket_code', keyPath: 'ticket_code', unique: true },
      { name: 'customer_id', keyPath: 'customer_id' },
      { name: 'create_user', keyPath: 'create_user' },
      { name: 'current_user', keyPath: 'current_user' },
      { name: 'department', keyPath: 'department' },
      { name: 'resolved', keyPath: 'resolved' }
    ],
    customers: [
      { name: 'code', keyPath: 'code' },
      { name: 'name', keyPath: 'name' },
      { name: 'type', keyPath: 'type' },
      { name: 'cust_type', keyPath: 'cust_type' },
      { name: 'email', keyPath: 'email' },
      { name: 'telephone1', keyPath: 'telephone1' }
    ],
    customer_contacts: [
      { name: 'telephone', keyPath: 'telephone', unique: true },
      { name: 'whatsapp', keyPath: 'whatsapp', unique: true },
      { name: 'email', keyPath: 'email', unique: true }
    ],
    ticket_users: [
      { name: 'ticket_id', keyPath: 'ticket_id' },
      { name: 'user_id', keyPath: 'user_id' },
      { name: 'department', keyPath: 'department' },
      { name: 'access_level', keyPath: 'access_level' }
    ],
    whatsapp_read: [
      { name: 'read_status', keyPath: 'read_status' },
      { name: 'message_id', keyPath: 'message_id', unique: true }
    ]
  }
}; 